import React, { useEffect } from "react";
import { useViewport } from "@bookingcom/bui-react";
import useSegment from "./useSegment.js";
import { OriginDestinationHorizontal } from "../OriginDestination/index.js";
import { DateDropDown } from "../Date/index.js";
import RemoveSegment from "./RemoveSegment.js";
import { OccupancyButtonDropDown } from "../Occupancy/index.js";
import styles from "./SegmentHorizontal.module.css";
const SegmentHorizontal = () => {
    const { isMultiStop, segments, fixInputSpacing, onGetSBExperimentVariant, onTrackSBExperimentStage, routeName, i18n, isResponsiveFixes } = useSegment();
    const { isLarge } = useViewport();
    const isVariant = !isMultiStop && !!onGetSBExperimentVariant("flights_web_ddot_sb_date_box_size", 1);
    useEffect(() => {
        if (isMultiStop)
            return;
        onTrackSBExperimentStage({ name: "flights_web_ddot_sb_date_box_size", stage: 1 });
        if (routeName === "home")
            onTrackSBExperimentStage({ name: "flights_web_ddot_sb_date_box_size", stage: 2 });
        if (routeName?.includes("searchresults"))
            onTrackSBExperimentStage({ name: "flights_web_ddot_sb_date_box_size", stage: 3 });
        if (i18n.language.toLowerCase() === "de")
            onTrackSBExperimentStage({ name: "flights_web_ddot_sb_date_box_size", stage: 4 });
    }, [isMultiStop, onTrackSBExperimentStage, routeName, i18n]);
    const isResponsiveFixesNotMultiStop = !isMultiStop && !isLarge && isResponsiveFixes;
    const isResponsiveFixesMultiStop = isMultiStop && !isLarge && isResponsiveFixes;
    return (React.createElement("div", { className: styles.wrapper }, segments.map((_, idx) => {
        const segmentContent = (React.createElement("div", { className: `${styles.line} ${isResponsiveFixesNotMultiStop ? styles.lineVertical : ""} ${isResponsiveFixesMultiStop ? styles.lineVerticalMultiStop : ""}`, "data-ui-name": "segments_list_item", style: {
                gridTemplateColumns: isVariant
                    ? "60fr 22fr 18fr"
                    : !isMultiStop
                        ? fixInputSpacing
                            ? "60fr 22fr 18fr"
                            : "6fr 2fr 2fr"
                        : "5fr 2fr"
            } },
            React.createElement("div", { className: `${styles.destination} ${isResponsiveFixesMultiStop ? styles.destinationVertical : ""}` },
                React.createElement(OriginDestinationHorizontal, { segmentIndex: idx })),
            React.createElement("div", { className: `${styles.date} ${isResponsiveFixesMultiStop ? styles.dateVertical : ""}` },
                React.createElement(DateDropDown, { segmentIndex: idx })),
            !isMultiStop ? React.createElement(OccupancyButtonDropDown, null) : undefined,
            isMultiStop ? (React.createElement("div", { className: `${styles.remove} ${isResponsiveFixesMultiStop ? styles.removeVertical : ""}` },
                React.createElement(RemoveSegment, { disabled: segments.length === 1, segmentIndex: idx }))) : null));
        return isMultiStop ? React.createElement("fieldset", { key: idx }, segmentContent) : React.createElement("div", { key: idx }, segmentContent);
    })));
};
export default SegmentHorizontal;
